import React from 'react';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Card, CardContent } from '@mui/material';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

import {
  PayPalButtons,
} from "@paypal/react-paypal-js";
import { useEffect, useState } from "react";
import { setRecordPaymentResponse } from '../../redux/actions/recordPaymentActions';
import { pushBookingSuccessfull } from '../../gtm';
import ReactGA from "react-ga4";
import AffiliateTracking from '../AffiliateTracking';
import ProgressBar from '../ProgressBar/ProgressBar';
import DropIn from './DropIn';



// This values are the props in the UI
const amount = "2";
const style = { "layout": "horizontal" };



const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#FCFDFD',
  },
  title: {
    color: '#444',
    fontSize: '22px',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: '700',
    backgroundColor: '#fff',
    textAlign: 'center',
    lineHeight: '1.1',
    marginBottom: '20px'
  },
  title2: {
    textAlign: 'center',
    fontSize: '1.8rem',
    fontWeight: '700',
    color: '#333',
    fontFamily: 'Nexa,sans-serif',
    lineHeight: '1.1',
  },
  subtitle: {
    textAlign: 'center',
    fontSize: '20px',
    lineHeight: '1.1',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: '500',
    color: '#265886',
    marginTop: '20px',
    backgroundColor: '#F7FBFF'
  },
  subtitle1: {
    textAlign: 'center',
    fontSize: '1em',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    fontWeight: '700',
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
    textTransform: 'none',
  },
  underline: {
    position: 'relative',
    display: 'inline-block',
  },
  underlineBefore: {
    position: 'absolute',
    content: '""',
    left: 40,
    right: 0,
    bottom: -8,
    height: '5px',
    width: '40%',
    backgroundColor: '#138911',
    borderRadius: '5px',
  },
  button1: {
    backgroundColor: 'rgb(17, 137, 17)',
    color: 'rgb(255, 255, 255)',
    borderRadius: '6px',
    marginTop: '14px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
  },
  button2: {
    backgroundColor: '#265886',
    color: 'rgb(255, 255, 255)',
    borderRadius: '6px',
    marginTop: '14px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
  },
  luggageSection: {
    marginTop: '20px',
  },
  luggageTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  termsInfo: {
    color: '#265886',
    fontSize: '22px',
    marginBottom: '-5px'
  },
  luggageButton: {
    display: 'flex',
    alignItems: 'center',
  },
  luggageIcon: {
    marginRight: '5px',
  },
  tickIcon: {
    fontWeight: 'bold'
  },
  terms: {
    fontSize: '16px',
    fontFamily: "Nexa,sans-serif",
    color: '#265886'
  },
  price1: {
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontSize: '30px',
    color: '#265886',
  },
  price2: {
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontSize: '17px',
    color: '#265886',
    marginLeft: '150px',
    marginTop: '10px'
  },
  ccImg: {
    background: `url('/assets/visa-mastercard-logos.png') no-repeat center`,
    backgroundSize: '100%',
    height: '56px',
    width: '150px',
    margin: '0 auto 6px auto',
  },
});


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  },

}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#F7FBFF",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));

const PaymentForm = ({ classes, theme, currency, showSpinner }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  const travelDetails = useSelector(state => state.travelDetails);
  const destinationType = {
    AIRPORT: 'AIR',
    RESORT: 'RES',
    TRAIN: 'TRBU',
    FERRY: 'FERR',
    BUS: 'BUS',
    GOLF: 'GOLF',
    LOCATION: 'LOCATION',
    CITY: 'CITY'
  };

  // Function to get outbound time label based on the origin and destination types
  const getOutTimeLabel = (fromType, toType) => {
    if (fromType === destinationType.GOLF && toType === destinationType.AIRPORT) return 'Flight Departure Time';
    if (fromType === destinationType.GOLF && toType === destinationType.BUS) return 'Bus Departure Time';
    if (fromType === destinationType.GOLF && toType === destinationType.FERRY) return 'Cruise Embarkation Time';
    if (fromType === destinationType.GOLF && toType === destinationType.GOLF) return 'Tee Time';
    if (fromType === destinationType.GOLF && toType === destinationType.TRAIN) return 'Train Departure Time';
    if (fromType === destinationType.GOLF && toType === destinationType.RESORT) return 'Pick Up Time';

    if (fromType === destinationType.RESORT && toType === destinationType.AIRPORT) return 'Flight Departure Time';
    if (fromType === destinationType.RESORT && toType === destinationType.BUS) return 'Bus Departure Time';
    if (fromType === destinationType.RESORT && toType === destinationType.FERRY) return 'Cruise Embarkation Time';
    if (fromType === destinationType.RESORT && toType === destinationType.GOLF) return 'Tee Time';
    if (fromType === destinationType.RESORT && toType === destinationType.TRAIN) return 'Train Departure Time';
    if (fromType === destinationType.RESORT && toType === destinationType.RESORT) return 'Pick Up Time';

    if (fromType === destinationType.AIRPORT) return 'Flight Arrival Time';
    if (fromType === destinationType.BUS) return 'Bus Arrival Time';
    if (fromType === destinationType.FERRY) return 'Cruise Disembarkation Time';
    if (fromType === destinationType.TRAIN) return 'Train Arrival Time';

    return 'Pick Up Time'; // Default case
  };

  // Function to get return time label based on the origin and destination types
  const getReturnTimeLabel = (fromType, toType) => {
    if (fromType === destinationType.GOLF && toType === destinationType.AIRPORT) return 'Flight Arrival Time';
    if (fromType === destinationType.GOLF && toType === destinationType.BUS) return 'Bus Arrival Time';
    if (fromType === destinationType.GOLF && toType === destinationType.FERRY) return 'Cruise Disembarkation Time';
    if (fromType === destinationType.GOLF && toType === destinationType.GOLF) return 'Tee Time';
    if (fromType === destinationType.GOLF && toType === destinationType.TRAIN) return 'Train Arrival Time';
    if (fromType === destinationType.GOLF && toType === destinationType.RESORT) return 'Pick Up Time';

    if (fromType === destinationType.RESORT && toType === destinationType.AIRPORT) return 'Flight Arrival Time';
    if (fromType === destinationType.RESORT && toType === destinationType.BUS) return 'Bus Arrival Time';
    if (fromType === destinationType.RESORT && toType === destinationType.FERRY) return 'Cruise Disembarkation Time';
    if (fromType === destinationType.RESORT && toType === destinationType.GOLF) return 'Pick Up Time';
    if (fromType === destinationType.RESORT && toType === destinationType.TRAIN) return 'Train Arrival Time';

    if (fromType === destinationType.AIRPORT) return 'Flight Departure Time';
    if (fromType === destinationType.BUS) return 'Bus Departure Time';
    if (fromType === destinationType.FERRY) return 'Cruise Embarkation Time';
    if (fromType === destinationType.TRAIN) return 'Train Departure Time';

    return 'Pick Up Time'; // Default case
  };
  const transportTypeMapping = {
    AIR: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Flight Number",
      RES: "Flight Number",
      TRBU: "Train Number",
    },
    BUS: {
      AIR: "Bus Number",
      BUS: "Bus Number",
      FERR: "Bus Number",
      GOLF: "Bus Number",
      RES: "Bus Number",
      TRBU: "Bus Number",
    },
    FERR: {
      AIR: "Cruise Number",
      BUS: "Cruise Number",
      FERR: "Cruise Number",
      GOLF: "Cruise Number",
      RES: "Cruise Number",
      TRBU: "Cruise Number",
    },
    GOLF: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Tee Time",
      RES: "Pick Up Time",
      TRBU: "Train Number",
    },
    RES: {
      AIR: "Flight Number",
      BUS: "Bus Number",
      FERR: "Cruise Number",
      GOLF: "Tee Time",
      RES: "Pick Up Time",
      TRBU: "Train Number",
    },
    TRBU: {
      AIR: "Train Number",
      BUS: "Train Number",
      FERR: "Train Number",
      GOLF: "Train Number",
      RES: "Train Number",
      TRBU: "Train Number",
    },
  };


  // Function to get transport type based on destination types
  const getTransportType = (fromType, toType) => {
    if (transportTypeMapping[fromType] && transportTypeMapping[fromType][toType]) {
      return transportTypeMapping[fromType][toType];
    }
    return "Transport Number"; // Fallback if no mapping is found
  };
  //  Get transport types based on travel details
  const fromType = travelDetails.pickupValue.type; // e.g., 'AIR'
  const toType = travelDetails.dropoffValue.type;  // e.g., 'RES'

  const transportTypeOutbound = getTransportType(fromType, toType);
  const transportTypeReturn = getTransportType(toType, fromType);
  // Function to get transport time label based on the origin and destination types

  const getTransportTimeLabel = (fromType, toType, isOutbound) => {
    return isOutbound ? getOutTimeLabel(fromType, toType) : getReturnTimeLabel(fromType, toType);
  };

  // Sample usage
  const outboundTimeLabel = getTransportTimeLabel(travelDetails.pickupValue.type, travelDetails.dropoffValue.type, true); // Outbound
  const returnTimeLabel = getTransportTimeLabel(travelDetails.pickupValue.type, travelDetails.dropoffValue.type, false); // Return




  const [paymentProvider, setPaymentProvider] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchPaymentGatewayProvider = async () => {
      try {
        const response = await fetch(`${apiBaseUrl}/system/paymentGatewayProvider`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
        });

        if (response.ok) {
          const data = await response.json();
          setPaymentProvider(data.paymentGatewayProvider);
        } else {
          console.error("Failed to fetch payment provider");
        }
      } catch (error) {
        console.error("Error fetching payment provider:", error);
      }
    };

    fetchPaymentGatewayProvider();
  }, [apiBaseUrl]);




  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const bookingDetails = useSelector((state) => state.customer);
  const { totalCost } = useSelector((state) => state.booking);
  
  const createBookingResponse = useSelector(state => state.createBooking);


  const [resToRes, setResToRes] = useState(false);

  useEffect(() => {
    if (createBookingResponse.basket.transfers[0]?.fromDestination.destinationTypeCode === 'RES'
        && createBookingResponse.basket.transfers[0]?.toDestination.destinationTypeCode === 'RES'
    ) {
      setResToRes(true);
    }
  }, [createBookingResponse]);


  useEffect(() => {

  }, [currency, showSpinner]);

  const newCost = parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2));


  const paypalKey = process.env.REACT_APP_PAYPAL_KEY;
  const currencySymbols = {
    GBP: '£', // British Pound
    USD: '$', // US Dollar
    EUR: '€', // Euro
    CAD: 'C$', // Canadian Dollar
    CHF: 'CHF', // Swiss Franc
    NOK: 'kr', // Norwegian Krone
    SEK: 'kr', // Swedish Krona
    AED: 'AED', // United Arab Emirates Dirham
    DKK: 'kr', // Danish Krone
  };


  return (
    <div>
      <Grid container spacing={2} sx={{
        flexGrow: 1,
        backgroundColor: '#FCFDFD',
      }} className={`${classes.root} ${classes.spacing}`}>
         {/* Progress Bar Section */}
         <Grid
          item
          xs={12}
          md={9}
          sx={{
            marginLeft: { xs: '-80px', sm: '-50px', md: '0px', lg: '170px' }, // Responsive margin for progress bar
          }}
          style={{
            display: 'flex',
            justifyContent: 'center', // Right align for larger screens, center for smaller
            alignItems: 'center',
            padding: '0 10px 10px 0',
          }}
        >
          <ProgressBar currentStep={4} />
        </Grid>
        {/* TITLE */}
        <Grid item
          xs={12}
          md={6}
          lg={6}
          sx={{
            marginLeft: { xs: '-60px', sm: '-220px', md: '108px', lg: '80px' }, // Responsive margin for heading
          }}>
          <Typography variant="h2" sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            textAlign: 'center',
            fontSize: '1.9rem',
            fontWeight: '700',
            color: '#333',
            fontFamily: 'Nexa,sans-serif',
            lineHeight: '1.1',
          }}>
            <span className={classes.underline}> Payment<span className={classes.underlineBefore}></span></span>
          </Typography>
        </Grid>
       

        <Grid item xs={12} md={1}></Grid>
        <Grid item xs={12} md={6} sx={{ marginTop: '30px' }}>
          <Card>
            <CardContent>

              <Typography variant="h5" sx={{
                textAlign: 'center',
                fontSize: '1.5rem',
                fontWeight: '700',
                color: '#333',
                fontFamily: 'Nexa,sans-serif',
                lineHeight: '1.1', marginBottom: '10px'
              }}>
                Payment Details
              </Typography>
              <Typography variant="h6" sx={{
                textAlign: 'center',
                fontSize: '1.4rem',
                fontWeight: 'bold',
                color: '#333',
                fontFamily: 'Nexa,sans-serif',
                marginBottom: '20px'
              }}>
                Total to Pay: {currencySymbols[createBookingResponse.basket.currency[0]]} {newCost}
              </Typography>
              <div sx={{
                background: `url('/assets/visa-mastercard-logos.png') no-repeat center`,
                backgroundSize: '100%',
                height: '56px',
                width: '150px',
                margin: '0 auto 6px auto',
              }}></div>
              {paymentProvider === "paypal" && (
                <PayPalScriptProvider options={{
                  "client-id": paypalKey,
                  "currency": createBookingResponse.basket.currency[0],
                  "disable-funding": "bancontact,eps,giropay,ideal,mybank,p24,sepa,sofort,venmo,wechatpay" // Disable all except credit cards and PayPal
                }}>


                  <PayPalButtons
                    style={style}
                    disabled={false}
                    forceReRender={[amount, currency, style]}
                    fundingSource="card"
                    createOrder={(data, actions) => {
                      return actions.order
                        .create({
                          purchase_units: [
                            {
                              amount: {
                                currency_code: currency,
                                value: newCost,
                              },
                            },
                          ],
                        })
                        .then((orderId) => {
                          // Your code here after create the order

                          return orderId;
                        });
                    }}
                    onApprove={function (data, actions) {
                      return actions.order.capture().then(function (details) {

                        // Assuming 'status' indicates the payment status
                        if (details.status === 'COMPLETED') {





                          const ecommerce = {
                            currency: createBookingResponse.basket.currency[0],
                            value: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)), // order total.
                            transaction_id: createBookingResponse.basket.bookingId, // transaction reference
                            coupon: createBookingResponse.basket.promoCode, // if coupon was applied to the order, include it here

                            items: [{
                              item_name: createBookingResponse.basket.transfers[0].fromDestination.name + " to " + createBookingResponse.basket.transfers[0].toDestination.name,
                              price: parseFloat((Math.round(createBookingResponse.basket.totalToPay) / 100).toFixed(2)),
                              item_category: createBookingResponse.basket.transfers[0].transferType.description,
                              item_category2: createBookingResponse.basket.transfers.length > 1 ? "Return" : "One way",
                              quantity: 1
                            }]
                          };
                          // // Gather Booking Successfull Details for GTM
                          // const bookingSuccessfullDetails = {
                          //   'DLV - transactionId': details.purchase_units[0].payments.captures[0].id,
                          //   'DLV - transactionTotal': totalCost,
                          //   'transactionCurrency': createBookingResponse.basket.currency[0]
                          // };

                          // Push the Booking Successfull Details  to the data layer
                          pushBookingSuccessfull(ecommerce);

                          // Record Payment
                          const headers = {
                            'Content-Type': 'application/json'
                          };
                          const currentDateRef = new Date();
                          const formattedDateRef = currentDateRef.toISOString().replace(/[-T:]/g, "").slice(0, 14);

                          const paymentDetails = {
                            "basket": {
                              "id": createBookingResponse.basket.id
                            },
                            "payment": {
                              "method": "paypal",
                              "currency": createBookingResponse.basket.currency[0],
                              "amount": createBookingResponse.basket.totalToPay,
                              "result": true,
                              "error": "",
                              "correlation": "",
                              "transaction": details.purchase_units[0].payments.captures[0].id,
                              "paymentRef": `new-${createBookingResponse.basket.bookingId}-dt${formattedDateRef}`
                            }
                          }

                          fetch(`${apiBaseUrl}/basket/recordPayment`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(paymentDetails),
                          })
                            .then((response) => response.json())
                            .then((data) => {

                              dispatch(setRecordPaymentResponse(data));
                              // Clear any existing ecommerce data
                              window.dataLayer = window.dataLayer || [];
                              window.dataLayer.push({ ecommerce: null });


                              // Push the new purchase event
                              ReactGA.event({
                                event: 'purchase',
                                ecommerce: {
                                  transaction_id: createBookingResponse.basket.bookingId, // Unique transaction ID
                                  affiliation: 'Online Store', // Store or affiliation from which this transaction occurred
                                  value: totalCost, // Total transaction value
                                  currency: createBookingResponse.basket.currency[0], // Currency code
                                  tax: 0, // Total tax
                                  shipping: 0, // Shipping cost
                                  coupon: createBookingResponse.basket.promoCode, // Promo code used for the transaction
                                  items: createBookingResponse.basket.transfers.map(transfer => ({
                                    item_name: transfer.fromDestination.name + " to " + transfer.toDestination.name, // Name of the item
                                    item_id: transfer.id, // ID of the item (not shown in your code but should be included if available)
                                    price: transfer.price, // Price of the item
                                    item_brand: transfer.brand, // Brand of the item (not shown in your code but should be included if available)
                                    item_category: transfer.transferType.description, // Category of the item
                                    item_variant: transfer.variant, // Variant of the item such as size or color (not shown in your code)
                                    quantity: 1 // Quantity of the item
                                  }))
                                }
                              });



                              // Navigate to the success page
                              navigate('/success/true');
                            });
                        } else {
                          // console.log('Payment was not successful.');
                          // Handle the case when the payment was not successful
                        }


                        // window.dataLayer.push({
                        //   'event': 'newreactpp', // Triggered event for GTM
                        //   'transactionId': 'value1',   // Custom data variables
                        //   // Add more data variables as needed
                        // });
                        // Add the provided JavaScript code here

                      });
                    }}
                  />


                  <PayPalButtons
                    style={style}
                    disabled={false}
                    forceReRender={[amount, currency, style]}
                    fundingSource="paypal"
                    createOrder={(data, actions) => {
                      return actions.order
                        .create({
                          purchase_units: [
                            {
                              amount: {
                                currency_code: currency,
                                value: newCost,
                              },
                            },
                          ],
                        })
                        .then((orderId) => {
                          // Your code here after create the order

                          return orderId;
                        });
                    }}
                    onApprove={function (data, actions) {
                      return actions.order.capture().then(function (details) {

                        // Assuming 'status' indicates the payment status
                        if (details.status === 'COMPLETED') {








                          // Record Payment
                          const headers = {
                            'Content-Type': 'application/json'
                          };
                          const currentDateRef = new Date();
                          const formattedDateRef = currentDateRef.toISOString().replace(/[-T:]/g, "").slice(0, 14);

                          const paymentDetails = {
                            "basket": {
                              "id": createBookingResponse.basket.id
                            },
                            "payment": {
                              "method": "paypal",
                              "currency": createBookingResponse.basket.currency[0],
                              "amount": createBookingResponse.basket.totalToPay,
                              "result": true,
                              "error": "",
                              "correlation": "",
                              "transaction": details.purchase_units[0].payments.captures[0].id,
                              "paymentRef": `new-${createBookingResponse.basket.bookingId}-dt${formattedDateRef}`
                            }
                          }

                          fetch(`${apiBaseUrl}/basket/recordPayment`, {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(paymentDetails),
                          })
                            .then((response) => response.json())
                            .then((data) => {

                              data && (
                                <AffiliateTracking
                                  transactionTotal={createBookingResponse.basket.totalToPay}
                                  transactionId={createBookingResponse.basket.basketId}
                                  transactionCurrency={createBookingResponse.basket.currency[0]}
                                />
                              )

                              dispatch(setRecordPaymentResponse(data));
                              // Clear any existing ecommerce data
                              window.dataLayer = window.dataLayer || [];
                              window.dataLayer.push({ ecommerce: null });

                              // Push the new purchase event
                              window.dataLayer.push({
                                event: 'purchase',
                                ecommerce: {
                                  transaction_id: details.id, // Unique transaction ID
                                  affiliation: 'Online Store', // Store or affiliation from which this transaction occurred
                                  value: totalCost, // Total transaction value
                                  currency: createBookingResponse.basket.currency[0], // Currency code
                                  tax: 0, // Total tax
                                  shipping: 0, // Shipping cost
                                  coupon: createBookingResponse.basket.promoCode, // Promo code used for the transaction
                                  items: createBookingResponse.basket.transfers.map(transfer => ({
                                    item_name: transfer.fromDestination.name + " to " + transfer.toDestination.name, // Name of the item
                                    item_id: transfer.id, // ID of the item (not shown in your code but should be included if available)
                                    price: transfer.price, // Price of the item
                                    item_brand: transfer.brand, // Brand of the item (not shown in your code but should be included if available)
                                    item_category: transfer.transferType.description, // Category of the item
                                    item_variant: transfer.variant, // Variant of the item such as size or color (not shown in your code)
                                    quantity: 1 // Quantity of the item
                                  }))
                                }
                              });



                              // Navigate to the success page
                              navigate('/success/true');
                            });
                        } else {
                          // console.log('Payment was not successful.');
                          // Handle the case when the payment was not successful
                        }


                        // window.dataLayer.push({
                        //   'event': 'newreactpp', // Triggered event for GTM
                        //   'transactionId': 'value1',   // Custom data variables
                        //   // Add more data variables as needed
                        // });
                        // Add the provided JavaScript code here

                      });
                    }}
                  />
                </PayPalScriptProvider>)}
              {paymentProvider === "airwallex" && <DropIn />}
            </CardContent>
          </Card>
        </Grid>
        {/* OUTBOUND Transfer */}
        <Grid item xs={12} md={5} sx={{ marginTop: '30px' }}>
          <TableContainer component={Paper}>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={2} sx={{
                    textAlign: 'center',
                    fontSize: '1.4rem',
                    fontWeight: '700',
                    color: '#333',
                    fontFamily: 'Nexa,sans-serif',
                    lineHeight: '1.1',
                  }}>
                    Outbound Transfer
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell colSpan={2} sx={{
                    textAlign: 'center',
                    fontSize: '18px',
                    lineHeight: '1.1',
                    fontFamily: 'Nexa,sans-serif',
                    fontWeight: '500',
                    color: '#265886',
                    marginTop: '20px',
                    backgroundColor: '#F7FBFF'
                  }}>
                    {travelDetails.pickupValue.label}&nbsp;
                    <ChevronRightIcon style={{ fontWeight: 'bolder', verticalAlign: 'middle', marginBottom: '4px' }} />
                    &nbsp;{travelDetails.dropoffValue.label}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                    <strong> Departing Date  </strong>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                    {dayjs(travelDetails.outboundDate).format('D MMM, YYYY')}
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                    <strong> {outboundTimeLabel}</strong>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                    {travelDetails.outboundTime}
                  </StyledTableCell>
                </StyledTableRow>
                  {
                    resToRes === false && (
                          <StyledTableRow>
                            <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                              <strong> {transportTypeOutbound} </strong>
                            </StyledTableCell>
                            <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                              {createBookingResponse.basket.transfers[0].flightNumber}
                            </StyledTableCell>
                          </StyledTableRow>
                      )
                  }
                <StyledTableRow>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                    <strong> Adults  </strong>
                  </StyledTableCell>
                  <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                    {travelDetails.adultsCount}
                  </StyledTableCell>
                </StyledTableRow>
                {travelDetails.childrenCount.length > 0 && (
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                      <strong> Children </strong>
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                      {travelDetails.childrenCount.length}
                    </StyledTableCell>
                  </StyledTableRow>
                )}

              </TableBody>
            </Table>
          </TableContainer>

          {/* RETURN TRANSFER  */}
          {
            createBookingResponse.basket.transfers.length > 1 && (
              <TableContainer component={Paper} sx={{ marginTop: '20px' }}>
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell colSpan={2} sx={{
                        textAlign: 'center',
                        fontSize: '1.4rem',
                        fontWeight: '700',
                        color: '#333',
                        fontFamily: 'Nexa,sans-serif',
                        lineHeight: '1.1',
                      }}>
                        Return Transfer
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell colSpan={2} sx={{
                        textAlign: 'center',
                        fontSize: '18px',
                        lineHeight: '1.1',
                        fontFamily: 'Nexa,sans-serif',
                        fontWeight: '500',
                        color: '#265886',
                        marginTop: '20px',
                        backgroundColor: '#F7FBFF'
                      }}>
                        {travelDetails.dropoffValue.label} &nbsp;
                        <ChevronRightIcon style={{ fontWeight: 'bolder', verticalAlign: 'middle', marginBottom: '4px' }} />
                        &nbsp;{travelDetails.pickupValue.label}
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                        <strong> Return Date  </strong>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                        {dayjs(travelDetails.returnDate).format('D MMM, YYYY')}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                        <strong> {returnTimeLabel} </strong>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                        {travelDetails.returnTime}
                      </StyledTableCell>
                    </StyledTableRow>
                    {
                        resToRes === false && (
                            <StyledTableRow>
                              <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                                <strong> {transportTypeReturn} </strong>
                              </StyledTableCell>
                              <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                                {createBookingResponse.basket.transfers[1].flightNumber}
                              </StyledTableCell>
                            </StyledTableRow>
                        )
                    }
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                        <strong> Adults  </strong>
                      </StyledTableCell>
                      <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                        {travelDetails.adultsCount}
                      </StyledTableCell>
                    </StyledTableRow>
                    {travelDetails.childrenCount.length > 0 && (
                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row" style={{ textAlign: 'center' }}>
                          <strong> Children </strong>
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row" style={{ textAlign: 'left' }}>
                          {travelDetails.childrenCount.length}
                        </StyledTableCell>
                      </StyledTableRow>
                    )}

                  </TableBody>
                </Table>
              </TableContainer>)}
        </Grid>



      </Grid>







    </div>
  );
};

export default withStyles(styles, { withTheme: true })(PaymentForm);
